import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_drawer_opened: true,
  c_dialog: false,
  confirm_dialog: {
    open: false,
    title: "",
    message: "",
    loading: false,
    onConfirm: () => {},
    onCancel: () => {},
  },
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setDrawer: (state, action) => {
      state.is_drawer_opened = !state.is_drawer_opened;
    },
    toggleConfirmDialog: (state, { payload }) => {
      // state.c_dialog = !state.c_dialog
      state.confirm_dialog.open = !state.confirm_dialog.open;
      if (!payload) return;
      state.confirm_dialog.title = payload.title;
      state.confirm_dialog.message = payload.message;
      state.confirm_dialog.onConfirm = payload.onConfirm;
    },
    setConfirmDialogLoading: (state, action) => {
      state.confirm_dialog.loading = !state.confirm_dialog.loading;
    },
  },
});

export const {
  setLoading,
  setDrawer,
  toggleConfirmDialog,
  setConfirmDialogLoading,
} = appSlice.actions;

export default appSlice.reducer;
